/* eslint-disable no-useless */
import Plugin from './components/message.vue';

export default class Alert {
  static alerts: Array<{
    msg: string,
    options?: any,
    resolve: any,
    reject: any,
  }> = [];

  static doing: boolean = false;

  private defaultOpts: any = {
    hasCancelButton: false,
    handleClickModal: false,
    handleEscModal: false,
  };

  private instance: any;

  constructor(instance: any) {
    /* eslint-disable no-console */
    if (!instance) console.error('Vue instance is not defined');
  }

  public install(msg: string, options: any) {
    const alert = new Promise((resolve, reject) => {
      Alert.alerts.push({
        msg,
        options: { ...options, ...this.defaultOpts },
        resolve,
        reject,
      });
      this.eventLoop();
    });
    return alert;
  }

  Alert(msg: string, options: any = {}) {
    return new Promise((resolve, reject) => {
      this.instance = new Plugin({
        el: document.createElement('div'),
        data: {
          message: msg,
          ...options,
        },
      });
      document.body.appendChild(this.instance.$el);
      this.instance.$on('close', (type: string) => {
        /* eslint-disable default-case */
        switch (type) {
          /* eslint-disable prefer-promise-reject-errors */
          case 'Cancel': reject('Cancel'); break;
          case 'Close': reject('Close'); break;
          case 'Loading': {
            this.Alert('正在执行中... 请耐心稍等...', {
              hasCancelButton: false,
              AlertButtonText: '知道啦',
            }).then(() => this.instance.close());
            break;
          }
          case 'OK': resolve();
        }
      });
    });
  }

  eventLoop() {
    if (Alert.doing || Alert.alerts.length === 0) return;
    Alert.doing = true;
    const item: any = Alert.alerts.shift();
    this.Alert(item.msg, item.options).then(() => {
      if (this.instance.loading) item.resolve(this.instance.close);
      else item.resolve();
      Alert.doing = false;
      this.eventLoop();
    }).catch((err: Error) => {
      item.reject(err.message);
      Alert.doing = false;
      this.eventLoop();
    });
  }
}
